// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import SimpleSelect from '../../utils/FormWidgets/SimpleSelect';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
  StyledMobileBoxSelectableItem,
  StyledMobileBoxLabel,
} from '../../utils/Styles/DataBoxStyles';

const UserPartiesMobile = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  content,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onPartyClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  getPartyDates,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  getMember,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onRoleSelect,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  memberOptions,
}) => {
  return (
    <div>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {content.map(item => (
        <StyledMobileBoxItem
          key={item.partyId}
          href={`/party/${item.partyId}`}
          onClick={onPartyClick}
        >
          <StyledMobileBoxLabel>
            {item.partyLocation ? item.partyLocation.address : 'none'}{' '}
          </StyledMobileBoxLabel>
          <StyledMobileBoxItemRow>
            Party Name: <span>{item.partyName}</span>
          </StyledMobileBoxItemRow>
          <StyledMobileBoxItemRow>
            Party Dates: <span>{getPartyDates(item)}</span>
          </StyledMobileBoxItemRow>
          <StyledMobileBoxSelectableItem>
            <span>Party Member Role:</span>
            <SimpleSelect
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              onChange={onRoleSelect}
              value={getMember(item)?.memberRole || ''}
              name={item.partyId}
              data={memberOptions}
            />
          </StyledMobileBoxSelectableItem>
          <StyledMobileBoxItemRow>
            Relationship to BACH: <span>{item.memberAcquaintance}</span>
          </StyledMobileBoxItemRow>
        </StyledMobileBoxItem>
      ))}
    </div>
  );
};

export default UserPartiesMobile;
